export enum ApprovalStatusEnum {
  Approved = 'APPROVED',
  PartiallyApproved = 'PARTIALLY_APPROVED',
  NotApproved = 'NOT_APPROVED',
  All = 'ALL',
}
